const UPDATE_DOWNLOAD_COUNT = 'UPDATE_DOWNLOAD_COUNT';


const updateDownloadCount = (downloadCount) => ({
    type: UPDATE_DOWNLOAD_COUNT,
    payload: {
        downloadCount: downloadCount,
    },
});

export {
    UPDATE_DOWNLOAD_COUNT,
    updateDownloadCount
}